/**
 * Comportements globaux du site (ex Main.ts de l'application Vue) :
 *  - images .media : classe `loaded` quand l'image est chargée (fondu des images lazy, media/_media.scss)
 *  - bouton « retour en haut » .scrolltop : visible après un tiers d'écran, remonte au-dessus du footer
 *  - bandeau .bandeau-top : affiché tant que le cookie de session `bandeauId` ne contient pas son id
 *  - liens .ghostlink : survol → `active` sur les liens frères (cartes entièrement cliquables)
 *  - sélecteur #menu-category (liste d'articles) : navigation vers l'URL choisie
 *  - éléments .animated : classe `animated-active` à l'entrée dans l'écran
 */
UNYC.register('core', () => {
    /* Images : fondu une fois chargées */
    const lazyload = () => {
        UNYC.init('.media:not(.loaded)', 'lazyload', (media) => {
            const image = media.querySelector('img');
            if (!image) return;

            if (image.complete && image.naturalWidth > 0) {
                media.classList.add('loaded');
                return;
            }

            image.addEventListener('load', () => media.classList.add('loaded'), { once: true });
        });
    };

    /* Retour en haut */
    const scrollTop = () => {
        const button = document.querySelector('.scrolltop');
        const visible = (window.innerHeight / 3) - document.documentElement.scrollTop < 0;

        document.body.classList.toggle('show-scrolltop', visible);

        if (!visible || !button) return;

        button.setAttribute('style', 'right: 20px;');

        const footer = document.querySelector('.app-footer');
        const footerTop = footer ? footer.getBoundingClientRect().top : 0;
        const buttonTop = button.getBoundingClientRect().top;

        if (footerTop && buttonTop) {
            const difference = footerTop - buttonTop;

            if (difference < -60) {
                const mobile = document.body.clientWidth < 1024;
                const bottom = (-1 * difference) - 50 + (mobile ? 35 : 0);

                button.setAttribute('style', `right: 20px; bottom: ${bottom}px;`);
            }
        }
    };

    /* Bandeau (cookie de session, comme js-cookie sans expiration) */
    const bandeau = document.querySelector('.bandeau-top');

    if (bandeau) {
        const id = bandeau.getAttribute('id') || '';
        const close = document.querySelector('.bandeau-close');
        const stored = UNYC.cookie.get('bandeauId');

        if (!stored || stored !== id) {
            UNYC.cookie.set('bandeauId', '');
            // Retire un éventuel masquage : le CSS l'affiche en grille, qui porte l'animation d'ouverture.
            bandeau.style.removeProperty('display');
        }

        if (close) {
            close.addEventListener('click', (event) => {
                event.preventDefault();
                bandeau.style.display = 'none';
                UNYC.cookie.set('bandeauId', id);
            });
        }
    }

    /* Liens fantômes : nom accessible de repli tiré du titre de la carte */
    UNYC.qsa('a.ghostlink').forEach((link) => {
        const parent = link.parentElement;
        if (!parent) return;

        if (!link.getAttribute('aria-label') && !link.getAttribute('title') && !link.textContent.trim()) {
            const heading = parent.querySelector('h1, h2, h3, h4, .title, .titre, .card_titre, .card-title');
            link.setAttribute('aria-label', heading && heading.textContent.trim() ? heading.textContent.trim() : 'Lire la suite');
        }

        const siblings = (active) => parent.querySelectorAll('a').forEach((a) => a.classList.toggle('active', active));

        link.addEventListener('mouseenter', () => siblings(true));
        link.addEventListener('mouseleave', () => siblings(false));
    });

    /* Sélecteur de catégorie */
    const categorySelect = document.getElementById('menu-category');

    if (categorySelect instanceof HTMLSelectElement) {
        categorySelect.addEventListener('change', () => {
            window.location.href = categorySelect.value;
        });
    }

    /* Animations à l'apparition */
    const animated = UNYC.qsa('.animated');

    if (animated.length) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) entry.target.classList.add('animated-active');
            });
        }, { threshold: 0.15, rootMargin: '-15% 0px' });

        animated.forEach((el) => observer.observe(el));
    }

    /* Scroll */
    window.addEventListener('scroll', UNYC.throttleFrame(() => {
        lazyload();
        scrollTop();
    }), { passive: true });

    lazyload();
    scrollTop();
});
